import React, { useMemo } from "react";
import cx from "clsx";
import { PatternAutocomplete } from "../../../../../../../../../../../widgets/PatternAutocomplete/PatternAutocomplete";
import styles from "./styles.module.scss";
import { useDebouncedState } from "../../../../../../../../../../../utilities/hooks/useDebouncedState";
import { useSmsSnippetsQuery } from "../../../../../../../../../../../api/smsSnippets/useSmsSnippetsQuery";

export const MessageTextarea = ({
  value,
  onChange,
  placeholder,
  maxLength,
  maxRows,
  className,
  isDisabled,
}) => {
  const [_, debouncedText, setText] = useDebouncedState("");

  const { data } = useSmsSnippetsQuery({
    name: debouncedText,
  });

  const substitutes = useMemo(
    () =>
      data?.map((x) => ({
        label: x.name,
        value: x.phrase,
        description: x.title,
      })) || [],
    [data],
  );

  return (
    <PatternAutocomplete
      patterns={[
        {
          match: ".",
          substitutes,
        },
      ]}
      value={value}
      placeholder={placeholder}
      maxLength={maxLength}
      maxRows={maxRows}
      className={cx(className, styles.textarea)}
      isDisabled={isDisabled}
      containerClassName={styles.root}
      onTokenFound={({ matchedText }) => setText(matchedText)}
      onChange={(value) =>
        onChange({
          target: {
            value,
          },
        })
      }
    />
  );
};
